import {DashboardService} from "../../../worklist/services/dashboard.service";
import {WorkflowService} from "@ispm/workflow/services/workflow.service";
import {AuthenticationService} from "@ispm/user/services/authentication.service";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {CoreActionCreatorService} from "@ispm/core/services/core-action-creator.service";
import {ThemingService} from "../../../theming/services/theming.service";
import {NavigationService} from "@ispm/dashboard/navigation/services/navigation.service";
import {WebConfigService} from "@ispm/layout/services/webConfig.service";
import {EndpointService} from "@ispm/shared/services/endpoint.service";
import {DashboardHomeComponent} from "./home.component";
import { RouterManagerService } from "@ispm/core/services/router-manager.service";

export const HOME_COMPONENTS = [
  DashboardHomeComponent,
  // NavigationBarComponent ,
  // NavigationBarItemComponent,
  //  NavigationBarAppLauncherComponent
];

export const HOME_SERVICES = [
    DashboardService,
    CoreActionCreatorService,
    ThemingService,
    AuthenticationService,
    WorkflowService,
    NavigationService,
    RouterManagerService,
    WebConfigService,
    UserActionCreatorService,
    EndpointService,
    // CurationActionCreatorService
    // resolveClinicalParams,
    // resolveRetrieveGrowlTTLParams,
    // resolveWebConfigParams
];
